export const ALPHA = 'ALPHA';
export const BETA = 'BETA';
export const PRODUCTION = 'PRODUCTION';
export const PREVIEW = 'PREVIEW';

export const environmentSwitchOptions = [
  { value: PREVIEW, label: 'Preview / Staging (Default)', icon: 'eye-fill' },
  { value: PRODUCTION, label: 'Production / Live', icon: 'paper-plane' },
  { value: BETA, label: 'Sandbox', icon: 'type-bold' },
  { value: ALPHA, label: 'UAT', icon: 'font' },
];

export const environmentPublishSwitchOptions = [
  { value: PRODUCTION, label: 'Production / Live Data', icon: 'paper-plane' },
  { value: BETA, label: 'Sandbox', icon: 'type-bold' },
  { value: ALPHA, label: 'UAT', icon: 'font' },
];

export const envBaseUrl = (envType) => {
  switch (envType) {
    case ALPHA:
      return 'uat.';
    case BETA:
      return 'sandbox.';
    case PREVIEW:
      return 'preview.';
    case PRODUCTION:
      return '';
    default:
      return 'preview.';
  }
};

export const generateUrl = (projectDetail, envType) => {
  const { seoName } = projectDetail;
  return `${generateSurfaceUrl(envType, seoName)}api/v1/`;
};

export const generateSurfaceUrl = (envType, seoName, isVibe = false) => {
  const { REACT_APP_EXCHANGE, REACT_APP_ENVIRONMENT, REACT_APP_EXCHANGE_VIBE } = process.env;
  let exchangeUrl = REACT_APP_EXCHANGE;
  if (isVibe) exchangeUrl = REACT_APP_EXCHANGE_VIBE;

  let protocol = `https`;
  if (REACT_APP_ENVIRONMENT && REACT_APP_ENVIRONMENT.toLowerCase().trim().startsWith('dev')) {
    protocol = `http`;
  }
  let env = envBaseUrl(envType);
  return `${protocol}://${seoName}.${env}${exchangeUrl}`;
};

export const constructDeveloperApiDocsUrl = (domainName) => {
  let apiUrl = '';
  const APP_ENV = process.env.REACT_APP_ENVIRONMENT || 'DEVELOPMENT';
  if (APP_ENV && APP_ENV.toLowerCase().trim().startsWith('dev')) {
    const port = process.env.REACT_APP_EXCHANGE_ENGINE_PORT || '6002';
    apiUrl = `http://${domainName}:${port}/api/v1/docs`;
  } else {
    apiUrl = `https://${domainName}/api/v1/docs`;
  }
  return apiUrl;
};

export const getProtocolForCustomDomains = (projectDetail) => {
  const { REACT_APP_ENVIRONMENT } = process.env;
  const { projectType } = projectDetail;
  const isFreeProject = !projectType || projectType == 'FREE';
  let protocol = `https`;
  if (REACT_APP_ENVIRONMENT && REACT_APP_ENVIRONMENT.toLowerCase().trim().startsWith('dev')) {
    protocol = `http`;
  }
  return { protocol, isFreeProject };
};
